import React from 'react';
import { TONE_CLASS } from '../lib';
import type { BadgeTone } from '../../../types/marketingPushInterfaces';

interface PushBadgeProps {
  tone?: BadgeTone;
  children: React.ReactNode;
  title?: string;
}

/** Бейдж статуса/кода ошибки. Палитра тонов — в TONE_CLASS, чтобы статусы
 *  и ошибки не разъезжались по компонентам. */
export function PushBadge({ tone = 'neutral', children, title }: PushBadgeProps) {
  return (
    <span
      title={title}
      className={`inline-block rounded-full px-2 py-[2px] text-xs font-medium whitespace-nowrap ${TONE_CLASS[tone]}`}
    >
      {children}
    </span>
  );
}

export default PushBadge;
